import React from 'react'
import { NavDropdown, Row } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'
import "./header.css"
import logo from '../resourses/Logo Gualtieri.svg'
import logoWhite from '../resourses/Logo Gualtieri White.svg'
import arrowDown from '../resourses/arrow-down.png'
import logoGold from '../resourses/Logo Gualtieri.svg'
import { HashLink } from 'react-router-hash-link';

const Header = ({ cardHandler }) => {
    const [isSticky, setIsSticky] = React.useState(false)

    React.useEffect(() => {
        //add arrows 
        const arrows = Array.from(document.getElementsByClassName("arrow-menu"))
        arrows.forEach(e => e.remove())
        const dropdowns = Array.from(document.getElementsByClassName('navDrop'))
        dropdowns.forEach(element => {

            if (document.getElementsByClassName('arrow-menu')) {
                const arrow = document.createElement("img")
                arrow.setAttribute('class', 'arrow-menu')
                arrow.src = arrowDown
                element.firstChild.appendChild(arrow)
            }

        });
        //Make the menu sticky
        const header = document.getElementById('header')
        window.addEventListener('scroll', (() => {
            if (window.scrollY > 1) {
                header.classList.add('sticky')
                setIsSticky(true)
            } else {
                header.classList.remove('sticky')
                setIsSticky(false)
            }
        }))
        // Menu selector

        //Hamburger animation selector


        // CLICK EVENT ON HAMBURGER


    })
    let location = useLocation();
    const menuHambHandler = () => {
        const menuBtn = document.getElementById("hamburguer");
        const menuBarTop = document.getElementById("top");
        const menuBarMiddle = document.getElementById("middle");
        const menuBarBottom = document.getElementById("bottom");
        const menuNav = document.getElementById("menu-nav");
        //Expansion
        menuNav.classList.toggle("expanded")
        //Animation
        menuBtn.classList.toggle("hamburger-animate")
        menuBarMiddle.classList.toggle("middle-animate");
        menuBarTop.classList.toggle("top-animate");
        menuBarBottom.classList.toggle("bottom-animate");
    };
    let linkExpanded 
    let servicesExpanded 
    const dropControl = (e, who) => {
        switch (who) {
            case 'links':
                if (!linkExpanded) {

                    const list = Array.from(document.getElementsByClassName('drop-father-links')[0].childNodes)
                    list.forEach(e => {
                        e.style.display = "block"
                    })
                    document.getElementsByClassName('drop-father-links')[0].style.border="0px"
                    linkExpanded = true
                } else {
                    const list = Array.from(document.getElementsByClassName('drop-father-links')[0].childNodes)
                    list.forEach(e => {
                        e.style.display = "none"
                    })
                    linkExpanded = false
                }
                
                break;
                
            case 'services':
                if (!servicesExpanded) {
                    const list = Array.from(document.getElementsByClassName('drop-father-services')[0].childNodes)
                    list.forEach(e => {
                        e.style.display = "block"
                    })
                    servicesExpanded = true
                } else {
                    const list = Array.from(document.getElementsByClassName('drop-father-services')[0].childNodes)
                    list.forEach(e => {
                        e.style.display = "none"
                    })
                    servicesExpanded = false
                }
                
                break;

            default:
                break;
        }
    }
    return (
        <div>
            <div style={{ width: "100%", height: "0px", backgroundColor: "#2B817E" }}></div>

            <Row className="header mx-sm-0 mx-md-5 mx-0 pb-3 py-3" id="header" >

                <Link to="./" className="logo" href="#" ><img style={window.innerWidth > 860 ? { width: "100%", height: "80px", paddingBottom: "1rem" }:{ width: "80%", height: "60px" }} src={window.innerWidth > 860 ? (isSticky ? logo : logoWhite) : logoGold} alt=""/></Link>
                <nav className="nav-bar " id="nav-bar">
                    <ul className="nav-list">
                        <li><Link className="a-to-sub" to="/">INICIO</Link></li>
                        <li>
                            <NavDropdown className="nav-item a-to-sub navDrop p-0" title="SERVICIOS" id="nav-dropdown">


                                <NavDropdown.Item><Link className="a-to-sub" to="/servicios/embarques">EMBARQUES</Link></NavDropdown.Item>


                                <NavDropdown.Item> <Link className="a-to-sub" to="/servicios/entregas">ENTREGAS</Link></NavDropdown.Item>


                            </NavDropdown>
                        </li>
                        <li><Link className="a-to-sub" to="/nosotros">NOSOTROS</Link></li>
                        <li><HashLink className="a-to-sub" smooth to="/#contact">CONTACTO</HashLink></li>
                       
                    </ul>
                </nav>
                <div onClick={menuHambHandler} id="hamburguer" className="hamburger">
                    <span id="top" className="bar top"></span>
                    <span id="middle" className="bar middle"></span>
                    <span id="bottom" className="bar bottom"></span>
                </div>
                <nav id="menu-nav" className="menu-nav">
                    <ul className="menu-list  px-0">
                        <li><HashLink onClick={menuHambHandler} smooth to="/#homeContainer">INICIO</HashLink></li>
                        <li className="black drop-down-mine drop-control"><span onClick={(e) => dropControl(e, 'services')}>SERVICIOS <img className="arrow-menu-no" src={arrowDown} alt=""/> </span><ul className="nav-item drop-father-services  p-0" title="" id="nav-dropdown drop-">
                            <li><Link onClick={menuHambHandler}  to="/servicios/embarques">
                                EMBARQUES
                            </Link></li>
                            <li><Link onClick={menuHambHandler} to="/servicios/entregas">
                                ENTREGAS
                            </Link></li>
                        </ul>
                        </li>
                        <li><Link onClick={menuHambHandler} to="/nosotros">NOSOTROS</Link></li>
                        <li><HashLink onClick={menuHambHandler} smooth to="/#contact">CONTACTO</HashLink></li>
                    </ul>
                </nav>
            </Row>



        </div>
    )
}

export default Header